import { createProgressActions, createActionCreators } from '../utils';
import { createAction } from 'redux-actions';

const CLEAR = 'CLEAR_PROFILE';
const clear = createAction(CLEAR, () => {});

const fetch = createActionCreators(createProgressActions('FETCH_PROFILE'));
const post = createActionCreators(createProgressActions('POST_PROFILE'));

const actions = {
 clear: CLEAR,
};

export default actions;
export { fetch, post, clear };



// WEBPACK FOOTER //
// ./src/app/models/Profile/actions.ts